// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__393pR","signatureButtonsRight":"ModalSign_signatureButtonsRight__3GAUm"};